import React from 'react';
import InputMask from '@mona-health/react-input-mask';

/**
 * Wrapper de InputMask compatível com MUI v5.
 *
 * Uso via InputProps.inputComponent:
 *   <TextField
 *     InputProps={{
 *       inputComponent: MaskedInput,
 *       inputProps: { mask: '###.###.###-##' }
 *     }}
 *   />
 *
 * maskPlaceholder={null} desativa o caractere de preenchimento (equivalente ao maskChar="" do v2).
 */
const MaskedInput = React.forwardRef(function MaskedInput({ mask, maskPlaceholder = null, ...props }, ref) {
  return <InputMask mask={mask} maskPlaceholder={maskPlaceholder} {...props} ref={ref} />;
});

export default MaskedInput;
